import React from "react";
import "./Home.css";
import useScrollAnimation from "../hooks/useScrollAnimation";

const Home = () => {
  const titleRef = useScrollAnimation(200);
  const subtitleRef = useScrollAnimation(400);
  const searchRef = useScrollAnimation(600);

  return (
    <section id="home" className="home">
      <div className="home-inner">
        <h1 ref={titleRef} className="home-title animate-on-scroll animate-fade-in-up">
          كما يشتد الفتل باجتماع خيوطه،
        </h1>
        <h1 className="home-title">
          يشتد أثر التسويق بانسجام شركائه
          <div className="home-title-span animate-float">,,</div>
        </h1>

        <p ref={subtitleRef} className="home-subtitle animate-on-scroll animate-fade-in-up">
          عبر أداة البحث بالذكاء الاصطناعي، ابحث عن شريكك الآن يصلك الشريك
          المناسب بسرعة ودقة.
        </p>
        <div ref={searchRef} className="home-brand-container animate-on-scroll animate-scale-in">
          <div className="home-brand">Fatl AI</div>

          <div className="home-search">
            <input
              type="text"
              className="home-search-input"
              placeholder="ماهي الخدمة التي تريد؟"
            />
            <button className="home-search-button">
              ابحث عن شريكك الآن
              <span className="home-search-icon"><svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M13.3127 0.175049C11.3361 0.175217 9.38818 0.64808 7.63146 1.55419C5.87474 2.46029 4.36017 3.77337 3.21413 5.38386C2.06809 6.99435 1.3238 8.85556 1.04336 10.8122C0.762924 12.7688 0.954465 14.7642 1.60201 16.6317C2.24955 18.4993 3.33432 20.1849 4.7658 21.548C6.19729 22.911 7.93398 23.912 9.831 24.4674C11.728 25.0228 13.7303 25.1164 15.6709 24.7406C17.6115 24.3647 19.434 23.5302 20.9865 22.3067L26.3123 27.6326C26.5874 27.8982 26.9558 28.0452 27.3381 28.0419C27.7205 28.0385 28.0863 27.8852 28.3567 27.6148C28.627 27.3444 28.7804 26.9786 28.7837 26.5963C28.7871 26.2139 28.6401 25.8455 28.3744 25.5705L23.0486 20.2446C24.4894 18.4168 25.3865 16.2202 25.6373 13.9063C25.888 11.5924 25.4822 9.25466 24.4664 7.1606C23.4506 5.06654 21.8657 3.30078 19.8932 2.06539C17.9207 0.829996 15.6402 0.174893 13.3127 0.175049ZM3.83358 12.5709C3.83358 10.0569 4.83228 7.64579 6.60996 5.8681C8.38765 4.09041 10.7987 3.09172 13.3127 3.09172C15.8268 3.09172 18.2378 4.09041 20.0155 5.8681C21.7932 7.64579 22.7919 10.0569 22.7919 12.5709C22.7919 15.0849 21.7932 17.496 20.0155 19.2737C18.2378 21.0514 15.8268 22.0501 13.3127 22.0501C10.7987 22.0501 8.38765 21.0514 6.60996 19.2737C4.83228 17.496 3.83358 15.0849 3.83358 12.5709Z" fill="white"/>
</svg>
</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
